"use client"

import { useEffect } from "react"
import { Game } from "@/components/game"
import { ViewportProvider } from "@/contexts/viewport-context"

export default function HomePage() {
  // Disable browser right-click context menu
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault()
    }
    document.addEventListener("contextmenu", handleContextMenu)
    return () => document.removeEventListener("contextmenu", handleContextMenu)
  }, [])

  return (
    <ViewportProvider>
      <Game />
    </ViewportProvider>
  )
}
